// @flow

export function makeMap(lat:number=13.7851192, lng:number=100.5424854, zoom:number=15, id:string='map'):any{
  const google = window.google
  return new google.maps.Map(document.getElementById(id), {
    center: {lat, lng},
    zoom: zoom, 
  })
}